{
  "common": {
    "next": "Next",
    "back": "Back",
    "loading": "Loading …",
    "submit": "Submit bindingly",
    "submitting": "Sending …",
    "select": "— please select —",
    "yes": "Yes",
    "dash": "—"
  },
  "nav": {
    "title": "Client onboarding",
    "subtitle": "GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB",
    "impressum": "Legal notice",
    "datenschutz": "Privacy policy"
  },
  "lang": {
    "label": "Language",
    "de": "Deutsch",
    "en": "English",
    "ar": "العربية",
    "fr": "Français"
  },
  "onboarding": {
    "title": "Client onboarding",
    "subtitle": "Please briefly describe the facts of your matter. You can pause at any time — your entries are saved automatically.",
    "submittedTitle": "Thank you — we have received your request.",
    "submittedBody": "Your documents have been submitted. We will review the matter and get back to you within a few business days.",
    "submittedDashboardPrefix": "You can review the status at any time in your ",
    "submittedDashboardLink": "Dashboard",
    "submittedDashboardSuffix": " or arrange an online appointment there.",
    "steps": {
      "sachverhalt": "Facts",
      "fragebogen": "Questionnaire",
      "gegenseite": "Opposing party",
      "vollmacht": "Power of attorney",
      "uploads": "Documents",
      "review": "Review & submit"
    },
    "sachverhalt": {
      "rechtsgebietLabel": "Area of law",
      "beschreibungLabel": "Brief description of your matter",
      "beschreibungPlaceholder": "What happened? Who is involved? What steps have you taken so far?",
      "counter": "{{chars}} / 20,000 characters",
      "minHint": "at least 3 characters to continue"
    },
    "gegenseite": {
      "hint": "If no opposing party is currently known, please enter \"—\".",
      "nameLabel": "Name / company of the opposing party",
      "anschriftLabel": "Address (if known)",
      "vertretenLabel": "Legal representation of the opposing party (if known)"
    },
    "vollmacht": {
      "p1": "In the further course we will require a written power of attorney. It will be sent to you for signature after the facts have been reviewed (either electronically or by letter).",
      "p2": "Already now, please declare your general consent that the law firm GQL Gussone Quecke Legal reviews the matter and, where applicable, takes you on as a client.",
      "checkbox": "I instruct GQL Gussone Quecke Legal to review the facts set out here and to prepare a legal engagement."
    },
    "uploads": {
      "hint": "Please upload all relevant documents — in particular identification document (identification pursuant to the German Money Laundering Act (GwG)), power of attorney (if already granted), correspondence with the opposing party and other evidence."
    },
    "review": {
      "title": "Summary",
      "rechtsgebiet": "Area of law",
      "sachverhalt": "Facts",
      "gegenseite": "Opposing party",
      "vertretenDurch": "Represented by: {{name}}",
      "vollmachtErklaerung": "Power-of-attorney declaration",
      "fragebogen": "Questionnaire",
      "unterlagen": "Documents ({{count}})",
      "notReady": "Please complete the facts, opposing party and power-of-attorney declaration first."
    },
    "errors": {
      "alreadySubmitted": "You have already submitted.",
      "submitFailed": "Submission failed — please try again later.",
      "unexpected": "Unexpected error."
    }
  },
  "rechtsgebiete": {
    "arbeitsrecht": "Employment law",
    "mietrecht": "Tenancy law",
    "familienrecht": "Family law",
    "verkehrsrecht": "Traffic law",
    "strafrecht": "Criminal law",
    "kartellrecht": "Antitrust law",
    "vergaberecht": "Public procurement law",
    "verwaltungsrecht": "Administrative law",
    "sonstiges": "Other"
  },
  "upload": {
    "kategorieLabel": "File category",
    "kategorien": {
      "ausweis": "ID / identification",
      "vollmacht": "Power of attorney / engagement",
      "korrespondenz": "Correspondence (letters, e-mails)",
      "beweis": "Evidence / documents",
      "sonstiges": "Other"
    },
    "dropHint": "PDF, JPG, PNG, HEIC, ZIP · max. 10 MB per file",
    "tooBig": "File \"{{name}}\" is larger than 10 MB.",
    "failed": "Upload failed — please try again.",
    "remove": "Remove",
    "removeAria": "Remove {{name}}"
  },
  "questionnaire": {
    "title": "Questions about your case",
    "intro": "Please answer the following questions as completely as possible. Your information helps us assess your case correctly.",
    "optionalHint": "(optional)",
    "requiredHint": "Required field",
    "selectPlaceholder": "— please select —",
    "loading": "Loading questionnaire …",
    "answeredCount": "{{answered}} of {{total}} answered"
  },
  "legalNotice": {
    "deAuthoritative": "This legal text is binding in its German version. Translations are provided solely to aid understanding."
  },
  "register": {
    "title": "Registration",
    "subtitle": "So that we can record your enquiry in a structured manner, please register with your basic details. You will then receive a confirmation email.",
    "vorname": "First name",
    "nachname": "Last name",
    "geburtsdatum": "Date of birth",
    "email": "Email address",
    "required": "Required field",
    "einwilligungRequired": "Consent required",
    "einwilligung": "I consent to the processing of my data for the purpose of initiating a mandate. The data will be treated confidentially and is subject to attorney-client confidentiality (§ 43a Abs. 2 BRAO).",
    "captchaPlease": "Please confirm the CAPTCHA.",
    "submit": "Submit registration",
    "submitting": "Please wait …",
    "haveAccount": "Already registered?",
    "login": "Sign in",
    "errCaptcha": "The bot protection rejected the attempt. Please solve the CAPTCHA again.",
    "errValidation": "Please check the input fields.",
    "errRateLimit": "Too many registrations from this connection. Please try again later.",
    "errGeneric": "An error has occurred. Please try again later.",
    "errUnexpected": "An unexpected error has occurred."
  },
  "login": {
    "title": "Sign in",
    "subtitle": "You will receive a one-time login link by email. No password entry required.",
    "email": "Email address",
    "required": "Required field",
    "captchaPlease": "Please confirm the CAPTCHA.",
    "submit": "Request login link",
    "submitting": "Please wait …",
    "consumingTitle": "Signing in …",
    "wait": "Please wait a moment.",
    "sentTitle": "Login link has been sent",
    "sentBody": "If the email address is registered, we have sent a login link. The link is valid for 15 minutes.",
    "errorTitle": "Sign-in not possible",
    "errInvalid": "The login link is invalid or has expired.",
    "errGeneric": "Sign-in failed.",
    "errRequest": "Request failed.",
    "errCaptcha": "The bot protection rejected the attempt.",
    "newLink": "Request a new link",
    "register": "Register",
    "noAccount": "Not registered yet?",
    "registerNow": "Register now"
  },
  "verify": {
    "checkingTitle": "Confirmation is being verified …",
    "wait": "Please wait a moment.",
    "successTitle": "Email confirmed",
    "successBody": "Thank you — your access has been activated. You will be redirected to the Onboarding …",
    "errorTitle": "Confirmation not possible",
    "errInvalid": "The confirmation link is invalid or has already expired.",
    "errGeneric": "Confirmation failed.",
    "noToken": "No token in the link.",
    "registerNew": "Register again",
    "requestLogin": "Request login link"
  },
  "verifySent": {
    "title": "Confirmation email has been sent",
    "bodyWithEmail": "We have sent a confirmation link to {{email}}. Please click on it to open the Onboarding area.",
    "bodyNoEmail": "We have sent you a confirmation link by email. Please click on it to open the Onboarding area.",
    "validity": "The link is valid for 24 hours. Please check your spam folder if necessary.",
    "notArrivedPrefix": "If the email does not arrive, you can ",
    "notArrivedLink": "register again",
    "notArrivedSuffix": "."
  },
  "invite": {
    "checkingTitle": "Invitation is being verified …",
    "wait": "Please wait a moment.",
    "successTitle": "Welcome",
    "successBody": "Your access has been activated. You will be redirected to the Onboarding …",
    "errorTitle": "Invitation not possible",
    "errorInvalid": "The invitation link is invalid or has expired.",
    "errorGeneric": "Redemption failed.",
    "loginLink": "Request a login link instead"
  },
  "dashboard": {
    "loading": "Loading …",
    "notLoggedIn": "Not signed in",
    "welcome": "Welcome, {{name}}.",
    "subtitle": "Here you can edit your onboarding data or arrange an appointment.",
    "subtitleWithTax": "Here you can edit your onboarding data, complete the 2021 and 2022 tax information or arrange an appointment.",
    "name": "Name",
    "email": "Email",
    "verifiedSince": "Verified since",
    "logout": "Sign out",
    "requestH": "Your client enquiry",
    "submitted": "Your enquiry has been submitted. We are reviewing the matter and will be in touch within a few working days.",
    "draftHint": "You have a started onboarding draft. You can continue from there.",
    "continue": "Continue onboarding",
    "startHint": "Describe your matter to us, upload relevant documents — we will review the matter and be in touch.",
    "start": "Start onboarding",
    "taxH": "Haidar tax form for 2021 and 2022",
    "taxHint": "Please complete the information still required for the 2021 and 2022 partnership and personal income-tax returns and upload the supporting documents. Your entries are saved automatically.",
    "taxStart": "Open tax form",
    "taxContinue": "Continue tax form",
    "taxSubmitted": "The tax form has been submitted for review. Nothing is filed with ELSTER or the tax office from this portal.",
    "nachreichungH": "Submit additional documents",
    "nachreichungHint": "Here you can upload further documents (notices of termination, termination agreements, employment contract, payslips, correspondence, etc.). The files are transferred directly to your case file, provided one has already been created.",
    "terminH": "Arrange a 30-minute online appointment",
    "terminHint": "You can book a 30-minute slot directly with attorney Moritz Quecke. The appointment takes place as a Microsoft Teams meeting; you will receive the link by email after booking.",
    "bookButton": "Book appointment (opens a new window)",
    "bookInline": "Or book directly here in the window",
    "bookFrameTitle": "Book appointment",
    "bookSoon": "The booking page is currently being set up. As soon as it is available, a booking button will appear here."
  },
  "notFound": {
    "title": "Page not found",
    "subtitle": "The page requested does not exist.",
    "toRegister": "To registration"
  },
  "intake": {
    "title": "Questions about your case",
    "subtitle": "Please answer the following questions, upload the requested documents and grant the power of attorney. Your entries are saved automatically.",
    "notReady": "Please answer all required questions and grant the power of attorney.",
    "noQuestionnaireTitle": "No questionnaire assigned",
    "noQuestionnaire": "No case-specific questionnaire is assigned to this access. Please use the general registration."
  }
}
